<template>
  <span>{{formattedSize}}</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { formatFileSize } from '@/common/utils/files'

/**
 * @displayName File Size
 */
export default defineComponent({
  name: 'FileSizeDisplay',
  props: {
    /**
     * Given size
     */
    value: {
      type: Number,
      default: 0,
    },
    /**
     * Default value used when the prop value is falsy
     * Can be a string, which will be displayed as is
     * Or a number, which will be displayed in KB.
     */
    defaultValue: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    formattedSize (): string {
      const size: number = this.value
      if (size) {
        return formatFileSize(size)
      }
      return `${this.defaultValue}${typeof this.defaultValue === 'number' ? ' ' + this.$t('design-system.display.FileSizeDisplay.lblKB') : ''}`
    },
  },
})
</script>

<!--<docs>-->
<!--```vue-->
<!--<template>-->
<!--  <div>-->
<!--    <AppTextField v-model="size"-->
<!--                  placeholder="Type any number"-->
<!--                  label="Size"-->
<!--                  type="number"-->
<!--    />-->
<!--    <app-filesize-display :value="size"/>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--  import AppTextField from '@/common/AppTextField.vue'-->
<!--  export default {-->
<!--    components: { AppTextField },-->
<!--    data () {-->
<!--      return {-->
<!--        size: 0,-->
<!--      }-->
<!--    },-->
<!--  }-->
<!--</script>-->
<!--```-->
<!--</docs>-->
